import { List, Button } from "antd";
import { Icon } from "components/common";
import { useNavigate } from "hooks/useNavigate";
import { convertCamelCaseToReadable, localisedValue } from "utils";
import {
  BOOKINGS_LISTING_PATH,
  BOOKINGS_DETAIL_PATH,
  TASKS_LISTING_PATH,
  RMS_APPROVALS_LISTING_PATH,
  RMS_PAYMENTS_LISTING_PATH,
  AGREEMENTS_LISTING_PATH,
  BILLS_LISTING_PATH,
  WORK_ORDERS_LISTING_PATH,
  DEVELOPER_INVENTORY_LISTING_PATH,
  AGREEMENT_DETAIL_PATH,
  AMENITIES_LISTING_PATH,
  RESERVATIONS_LISTING_PATH,
} from "constants/app-paths";
import { useSelector } from "react-redux";
import { getCurrentApp } from "core/appRegistry";
import { getTimeAgoSimple } from "utils/date";
import { t } from "i18next";
import Flex from "components/common/flex";

const getNotificationDetailPath = (type, action, id) => {
  const currentAppKey =
    useSelector((state) => state.app.currentApp) || getCurrentApp()?.key;
  let pathName;

  const idQuery = id ? `?q[id_eq]=${id}` : "";

  if (currentAppKey === "developer") {
    switch (type) {
      case "Unit":
        pathName = `${DEVELOPER_INVENTORY_LISTING_PATH}?q[id_in]=${id}&classification=all_units`;
        break;
      default:
        return null;
    }
  } else {
    switch (type) {
      case "Approval":
        pathName = `/${currentAppKey}${RMS_APPROVALS_LISTING_PATH}${idQuery}`;
        break;
      case "Task":
        pathName = TASKS_LISTING_PATH;
        break;
      case "Booking":
        pathName =
          action === "detail"
            ? BOOKINGS_DETAIL_PATH.replace(":bookingId", id)
            : BOOKINGS_LISTING_PATH;
        break;
      case "Payment":
        pathName = `/${currentAppKey}${RMS_PAYMENTS_LISTING_PATH}${idQuery}`;
        break;
      case "Agreement":
        pathName =
          action === "detail"
            ? AGREEMENT_DETAIL_PATH.replace(":agreementId", id)
            : `/${currentAppKey}${AGREEMENTS_LISTING_PATH}${idQuery}`;
        break;
      case "MonthlyBill":
        pathName = `/${currentAppKey}${BILLS_LISTING_PATH}${idQuery}`;
        break;
      case "WorkOrder":
        pathName = `/${currentAppKey}${WORK_ORDERS_LISTING_PATH}${idQuery}`;
        break;
      case "Amenity":
        pathName = `/${currentAppKey}${AMENITIES_LISTING_PATH}${idQuery}`;
        break;
      case "AmenityReservation":
        pathName = `/${currentAppKey}${RESERVATIONS_LISTING_PATH}${idQuery}`;
        break;
      default:
        return null;
    }
  }

  return pathName;
};

const NotificationTile = ({ item, onMarkAsRead }) => {
  const navigate = useNavigate();
  const { payload, source_type, source_id, created_at, is_read, id } = item;
  const { icon, booking_number, action } = payload?.data || {};
  const path = getNotificationDetailPath(source_type, action, source_id);

  const handleTileClick = () => {
    onMarkAsRead(item);
  };

  const handleViewModule = (e) => {
    e.stopPropagation();
    if (path) {
      navigate(path);
    }
  };

  return (
    <div
      style={is_read === false ? { background: "#dff1e0" } : {}}
      onClick={handleTileClick}
      className="pointer"
    >
      <List.Item>
        <List.Item.Meta
          avatar={
            <Icon
              icon={"AiFillNotification"}
              style={{
                fontSize: "20px",
                color: "#009F2B",
                alignItems: "center",
              }}
            />
          }
          title={
            <Flex vertical align="start">
              {!!payload?.data?.title && (
                <b>{localisedValue({ object: payload?.data, key: "title" })}</b>
              )}
              {localisedValue({ object: payload?.data, key: "message" })}
            </Flex>
          }
          description={
            <>
              {booking_number && (
                <div>
                  {booking_number}
                  {created_at && <span style={{ margin: "0 8px" }}></span>}
                </div>
              )}
              {path && (
                <div>
                  <Button
                    type="link"
                    onClick={handleViewModule}
                    style={{
                      color: "#009F2B",
                      padding: 0,
                      height: "auto",
                      fontWeight: 500,
                    }}
                  >
                    {`${t("View")} ${t(convertCamelCaseToReadable(item?.source_type))}`}
                  </Button>
                </div>
              )}
            </>
          }
        />
        <div style={{ marginInlineStart: 8 }}>
          {getTimeAgoSimple(created_at)}
        </div>
      </List.Item>
    </div>
  );
};

export default NotificationTile;
